import { useCallback } from 'react';
import { usePostMessageChannel } from './usePostMessageChannel';

export function useNavigationPostMessage() {
  const { sendMessageToParentWindow } = usePostMessageChannel();

  const sendNavigationMessage = useCallback(
    (path: string) => {
      sendMessageToParentWindow('navigation', { path });
    },
    [sendMessageToParentWindow]
  );

  return { sendNavigationMessage };
}
